module.exports = __webpack_public_path__ + "img/map.8dcbdcf1.png";